/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Width_HelpInputs */

const en_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of characters across the screen (1-100)`)
};

const fr_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de caractères sur l'écran (1-100)`)
};

const de_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Zeichen auf dem Bildschirm (1-100)`)
};

const it_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di caratteri sullo schermo (1-100)`)
};

const ru_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество символов на экране (от 1 до 100)`)
};

const es_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de caracteres en la pantalla (1-100)`)
};

const zh_cn2_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屏幕上显示的字符数（1-100）`)
};

const ja_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面に表示される文字数（1～100）`)
};

const hi_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रीन पर वर्णों की संख्या (1-100)`)
};

const pt_pt2_options_display_width_help = /** @type {(inputs: Options_Display_Width_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de caracteres na tela (1-100)`)
};

/**
* | output |
* | --- |
* | "Number of characters across the screen (1-100)" |
*
* @param {Options_Display_Width_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_width_help = /** @type {((inputs?: Options_Display_Width_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Width_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_width_help(inputs)
	if (locale === "de") return de_options_display_width_help(inputs)
	if (locale === "it") return it_options_display_width_help(inputs)
	if (locale === "ru") return ru_options_display_width_help(inputs)
	if (locale === "es") return es_options_display_width_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_width_help(inputs)
	if (locale === "ja") return ja_options_display_width_help(inputs)
	if (locale === "hi") return hi_options_display_width_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_width_help(inputs)
	return en_options_display_width_help(inputs)
});